/* Sale return voucher for one Billed To group — printable A4 sheet + Excel. */
import * as XLSX from "xlsx";

const esc = (s) => String(s ?? "").replace(/[&<>"]/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
const COLS = ["#", "Return Date", "Tracking", "Invoice #", "Customer", "Country", "Product", "Batch", "Expiry", "Qty"];

const dmy = (iso) => { const m = String(iso || "").match(/^(\d{4})-(\d{2})-(\d{2})/); return m ? `${m[3]}/${m[2]}/${m[1]}` : (iso || ""); };

// One numbered line per parcel; extra products of the same parcel follow unnumbered.
const voucherLines = (rows) => {
  const out = [];
  rows.forEach((r, n) => (r.products?.length ? r.products : [{ name: "—", qty: r.total_qty || 0 }]).forEach((p, i) => out.push([
    i === 0 ? n + 1 : "",
    i === 0 ? dmy(r.return_date) : "", i === 0 ? r.tracking || "" : "", i === 0 ? r.invoice_no || "" : "",
    i === 0 ? r.customer_name || "" : "", i === 0 ? r.destination_country || "" : "",
    p.name || "", p.batch || "", p.exp || "", Number(p.qty) || 0,
  ])));
  return out;
};

const today = () => new Date().toLocaleDateString("en-GB");

export const printVoucher = (name, rows) => {
  const lines = voucherLines(rows);
  const total = lines.reduce((s, l) => s + l[9], 0);
  const w = window.open("", "_blank");
  if (!w) return false;
  w.document.write(`<html><head><title>Sale Return Voucher — ${esc(name)}</title><style>
@page{size:A4 portrait;margin:12mm}*{box-sizing:border-box;-webkit-print-color-adjust:exact;print-color-adjust:exact}
body{font-family:Calibri,'Segoe UI',Arial,sans-serif;color:#0f172a;margin:0;font-size:11px}
h1{font-size:18px;margin:0;color:#065f46;letter-spacing:.5px}.meta{display:flex;justify-content:space-between;align-items:flex-end;border-bottom:3px solid #065f46;padding-bottom:6px;margin-bottom:10px}
.bt{font-size:15px;font-weight:800}.lbl{color:#64748b;font-size:10px;text-transform:uppercase;letter-spacing:.6px}
table{width:100%;border-collapse:collapse}th{background:#ecfdf5;color:#065f46;font-size:10px;text-transform:uppercase;text-align:left}
th,td{border:1px solid #cbd5e1;padding:3px 5px;vertical-align:top}td.n{text-align:right;font-variant-numeric:tabular-nums}
tfoot td{font-weight:800;background:#f8fafc}.sig{display:flex;justify-content:space-between;margin-top:46px}.sig div{width:30%;border-top:1px solid #0f172a;padding-top:4px;text-align:center;color:#475569}
@media screen{body{background:#e2e8f0;padding:16px}.pg{background:#fff;max-width:800px;margin:0 auto;padding:22px;box-shadow:0 2px 10px #0003}}
</style></head><body><div class="pg"><div class="meta"><div><h1>SALE RETURN VOUCHER</h1><div class="lbl" style="margin-top:6px">Billed To</div><div class="bt">${esc(name || "Not set")}</div></div>
<div style="text-align:right"><div class="lbl">Date</div><b>${today()}</b><div class="lbl" style="margin-top:4px">Parcels / Qty</div><b>${rows.length} / ${total}</b></div></div>
<table><thead><tr>${COLS.map(c => `<th>${c}</th>`).join("")}</tr></thead><tbody>
${lines.map(l => `<tr>${l.map((v, i) => `<td${i === 0 || i === 9 ? ' class="n"' : ""}>${esc(v)}</td>`).join("")}</tr>`).join("")}
</tbody><tfoot><tr><td colspan="9" style="text-align:right">Total qty</td><td class="n">${total}</td></tr></tfoot></table>
<div class="sig"><div>Prepared by</div><div>Checked by</div><div>Authorised signatory</div></div></div>
<script>setTimeout(()=>window.print(),300)</script></body></html>`);
  w.document.close();
  return true;
};

export const excelVoucher = (name, rows) => {
  const lines = voucherLines(rows);
  const total = lines.reduce((s, l) => s + l[9], 0);
  const aoa = [["SALE RETURN VOUCHER"], ["Billed To", name || "Not set"], ["Date", today()], ["Parcels", rows.length], [], COLS, ...lines,
    ["", "", "", "", "", "", "", "", "Total qty", total]];
  const ws = XLSX.utils.aoa_to_sheet(aoa);
  ws["!cols"] = [5, 12, 18, 11, 22, 12, 30, 12, 10, 7].map(wch => ({ wch }));
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Voucher");
  XLSX.writeFile(wb, `Sale_Return_Voucher_${(name || "Not_set").replace(/[^\w]+/g, "_")}.xlsx`);
};
